import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';

import { propTypesDataWordCloud } from './WordCloud.proptypes.js';

import Button, { ButtonAppearance } from '../../../../ui/Atoms/Button';
import Input from '../../../../ui/Atoms/Input';

import { WordCloud } from './Cloud';

import * as S from './WordCloud.styles.js';

export const WordCloudSlice = ({ slice }) => {
  const [word, setWord] = useState('');
  const [updateId, setUpdateId] = useState(0);
  const { ref } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const {
    wordcloud_slice_id: id,
    wordcloud_title: { html: title } = {},
    wordcloud_placeholder: placeholder,
    wordcloud_send_label: sendLabel,
  } = data || '';

  const items = slice.items || {};

  const words = [];

  items.forEach(item => {
    words.push({ word: item.wordcloud_word, frequency: item.wordcloud_size });
  });

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [wordcloudWords, setWordcloudWords] = useState(words);

  if (!title) {
    Sentry.captureMessage('Error: missing required data in WordCloud slice');
    return null;
  }

  const handleKeyDown = ev => {
    if (ev.keyCode === 13 || ev.type === 'click') {
      word.split(' ').map(wordSplit => {
        if (wordcloudWords.find(w => w.word === wordSplit.toUpperCase())) {
          setWordcloudWords(
            wordcloudWords.map(w =>
              w.word === wordSplit.toUpperCase()
                ? { ...w, frequency: w.frequency + 1 }
                : { ...w }
            )
          );
        } else {
          setWordcloudWords(prevWordcloudWords => [
            ...prevWordcloudWords,
            {
              word: wordSplit.toUpperCase(),
              frequency: 1,
            },
          ]);
        }
        if (typeof window !== 'undefined' && window.dataLayer) {
          window.dataLayer.push({ wordcloudWord: wordSplit.toUpperCase() });
        }
        setUpdateId(updateId + 1);
        setWord('');
      });
    }
  };

  return (
    <S.Wrapper id={id} isVisible={true} ref={ref}>
      <S.ContentWrapper>
        <S.TitleWrapper>
          <S.Title>{title}</S.Title>
        </S.TitleWrapper>
        <S.InputWrapper>
          <Input
            hasFocus={false}
            onChange={ev => setWord(ev.target.value.substring(0, 50))}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            value={word}
          />
        </S.InputWrapper>
        <Button
          appearance={ButtonAppearance.OUTLINE}
          isDisabled={word.length < 1}
          onClick={handleKeyDown}
        >
          {sendLabel}
        </Button>
      </S.ContentWrapper>
      <WordCloud updateId={updateId} words={wordcloudWords} />
    </S.Wrapper>
  );
};

WordCloudSlice.propTypes = {
  /**
   * Content of the HeaderBasic slice.
   */
  slice: PropTypes.shape(propTypesDataWordCloud),
};
